module.exports = __webpack_public_path__ + "img/arrrow.3ffe35a0.svg";